var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { createSelector } from 'reselect';
import { createMaybeSelector } from '@ally/data-selectors';
import { getDomainData as getCustomizationDomainData } from '@ally/data-selectors-customization';
import * as accounts from './base';
import { formatInvestAccountsForDropdown, getByType } from './etc/utils';
var getOpenInvestAccounts = createSelector(accounts.getInvest, function (investAccounts) {
    return (investAccounts !== null && investAccounts !== void 0 ? investAccounts : []).filter(function (_a) {
        var accountStatus = _a.accountStatus;
        return accountStatus !== 'Closed';
    });
});
var getIsInvestUser = createSelector(accounts.getInvest, function (accountSummary) { return !!(accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.length); });
var getInvestAccountsForDropdown = createSelector(accounts.getInvest, getCustomizationDomainData, function (investSummary, customizationDomain) {
    if (investSummary === null)
        return [];
    return formatInvestAccountsForDropdown(investSummary, customizationDomain);
});
// pass one or multiple InvestAccountTypes. Will return true if all
// deposit accounts are of at least one of the types passed as a param
var getHasOnlyByAccountType = function () {
    var accountTypes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        accountTypes[_i] = arguments[_i];
    }
    return createMaybeSelector(accounts.getInvest, function (accountSummary) {
        return accountSummary.every(function (_a) {
            var accountType = _a.accountType;
            return accountTypes.includes(accountType);
        });
    });
};
var getInvestAccountsByType = function () {
    var accTypes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        accTypes[_i] = arguments[_i];
    }
    return createMaybeSelector(accounts.getInvest, getByType.apply(void 0, __spread(accTypes)));
};
var getINVA = getInvestAccountsByType('INVA');
var getINVS = getInvestAccountsByType('INVS');
var getINVW = getInvestAccountsByType('INVW');
export default {
    getAll: accounts.getInvest,
    getINVA: getINVA,
    getINVS: getINVS,
    getINVW: getINVW,
    getOpen: getOpenInvestAccounts,
    getAllForDropdown: getInvestAccountsForDropdown,
    getIsUser: getIsInvestUser,
    getHasOnlyByType: getHasOnlyByAccountType,
};
//# sourceMappingURL=invest.js.map